/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiQueryTemplateUpdateRequest
 */
export interface ApiQueryTemplateUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiQueryTemplateUpdateRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiQueryTemplateUpdateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ApiQueryTemplateUpdateRequest
     */
    content: string;
}

/**
 * Check if a given object implements the ApiQueryTemplateUpdateRequest interface.
 */
export function instanceOfApiQueryTemplateUpdateRequest(value: object): value is ApiQueryTemplateUpdateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ApiQueryTemplateUpdateRequestFromJSON(json: any): ApiQueryTemplateUpdateRequest {
    return ApiQueryTemplateUpdateRequestFromJSONTyped(json, false);
}

export function ApiQueryTemplateUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiQueryTemplateUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'content': json['content'],
    };
}

export function ApiQueryTemplateUpdateRequestToJSON(json: any): ApiQueryTemplateUpdateRequest {
    return ApiQueryTemplateUpdateRequestToJSONTyped(json, false);
}

export function ApiQueryTemplateUpdateRequestToJSONTyped(value?: ApiQueryTemplateUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'content': value['content'],
    };
}

